<!-- Zweck: Stellt die HTML-Struktur für shop dtp zusatzdaten field editor component im Frontend bereit. -->
@if (zusatzdaten && zusatzdaten.zusatzdaten) {
  <div style="margin-top: 10px">
    <div class="label">{{zusatzdaten.zusatzdaten.Bezeichnung}}</div>
    <div style="padding-left: 20px">
        @if (zusatzdaten.zusatzdaten.ZusatzdatenBasistyp == 'String') {
          <mat-form-field appearance="outline" [class.has-error]="(validationError|async)">
            <input matInput [(ngModel)]="zusatzdaten.data" type="text" (keydown)="setDirty()" [disabled]="disabled"
                   (keydown.enter)="save()">
            @if (validationError|async) {
              <div class="error">{{validationError|async}}</div>
            }
          </mat-form-field>
        } @else if (zusatzdaten.zusatzdaten.ZusatzdatenBasistyp == 'TxArea') {
          <mat-form-field appearance="outline" [class.has-error]="(validationError|async)">
            <textarea matInput [(ngModel)]="zusatzdaten.data" type="text" (keydown)="setDirty()" [disabled]="disabled"></textarea>
            @if (validationError|async) {
              <div class="error">{{validationError|async}}</div>
            }
          </mat-form-field>
        } @else if (zusatzdaten.zusatzdaten.ZusatzdatenBasistyp == 'PdfDok') {
          @if (zusatzdaten.zusatzdaten.PdfGeschwaerzt) {
            @if ((blackeningConfigBoxes|async)?.length > 0) {
              <div>
                <mat-button-toggle-group [(ngModel)]="zusatzdaten.dsgvoAutoBlackening" (change)="changeAutoBlackening()" [disabled]="disabled">
                  <mat-button-toggle [value]="true">Automatische Schwärzung</mat-button-toggle>
                  <mat-button-toggle [value]="false">Manuelle Schwärzung</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            }
            @if ((blackeningConfigBoxes|async)?.length == 0 || zusatzdaten.dsgvoAutoBlackening == false) {
              <div>
                <br>
                <h3>Datenschutz</h3>
                <mat-checkbox [(ngModel)]="zusatzdaten.dsgvoManualBlackening" (change)="dsgvoManualBlackeningChanged()" [disabled]="disabled">Das Rezept wurde von mir Datenschutzkonform geschwärzt</mat-checkbox>
              </div>
              <form-file-input
                [label]=""
                [(value)]="zusatzdaten.file"
                [previewEnabled]="!!warenkorbId"
                [mobileUploadEnabled]="true"
                [uploadPercentage]="uploadPercentage|async"
                [disabled]="disabled || !zusatzdaten.dsgvoManualBlackening"
                [typeFilter]="[
                  'image/jpeg',
                  'image/png',
                  'application/pdf',
                ]"
                (change)="delayedSave()"
                (preview)="preview()"
                (cleared)="clear()"
              ></form-file-input>
            } @else {
              <form-file-input
                [label]=""
                [(value)]="zusatzdaten.file"
                [previewEnabled]="!!warenkorbId"
                [mobileUploadEnabled]="false"
                [uploadPercentage]="uploadPercentage|async"
                [disabled]="disabled"
                [typeFilter]="[
                'application/pdf',
                ]"
                (change)="delayedSave()"
                (preview)="preview()"
                (cleared)="clear()"
              ></form-file-input>
            }


          } @else {
            <form-file-input
              [label]=""
              [(value)]="zusatzdaten.file"
              [previewEnabled]="!!warenkorbId"
              [mobileUploadEnabled]="true"
              [uploadPercentage]="uploadPercentage|async"
              [disabled]="disabled"
              [typeFilter]="[
                'image/jpeg',
                'image/png',
                'application/pdf',
              ]"
              (change)="delayedSave()"
              (preview)="preview()"
              (cleared)="clear()"
            ></form-file-input>
          }
        } @else if (zusatzdaten.zusatzdaten.ZusatzdatenBasistyp == 'Int') {
          <mat-form-field appearance="outline" [class.has-error]="(validationError|async)">
            <input type="number" matInput [(ngModel)]="zusatzdaten.data" step="1" (keydown)="setDirty()" [disabled]="disabled"
                   (keydown.enter)="save()">
            @if (validationError|async) {
              <div class="error">{{validationError|async}}</div>
            }
          </mat-form-field>
        } @else if (zusatzdaten.zusatzdaten.ZusatzdatenBasistyp == 'Double') {
          <mat-form-field appearance="outline" [class.has-error]="(validationError|async)">
            <input type="number" matInput [(ngModel)]="zusatzdaten.data" step="0.01" (keydown)="setDirty()" [disabled]="disabled"
                   (keydown.enter)="save()">
            @if (validationError|async) {
              <div class="error">{{validationError|async}}</div>
            }
          </mat-form-field>
        } @else if (zusatzdaten.zusatzdaten.ZusatzdatenBasistyp == 'Date') {
          <mat-form-field appearance="outline" [class.has-error]="(validationError|async)">
            <input matInput [(ngModel)]="zusatzdaten.data" [matDatepicker]="picker" (keydown)="setDirty()" (dateChange)="setDirty()" [disabled]="disabled"
                   (keydown.enter)="save()">
            <mat-hint>DD.MM.YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (validationError|async) {
              <div class="error">{{validationError|async}}</div>
            }
          </mat-form-field>
        } @else {
          <div>
            Unknown - {{zusatzdaten.zusatzdaten.Bezeichnung}}({{zusatzdaten.matchcode}}) [{{zusatzdaten.zusatzdaten.ZusatzdatenBasistyp}}]
          </div>
        }

        @if (loading|async) {
          <div style="display: inline-block; width: 72px; height: 40px; text-align: center;">
            <div style="display: inline-block;">
              <mat-spinner diameter="40"></mat-spinner>
            </div>
          </div>
        } @else if (!disabled) {
          @if (dirty|async) {
            <button mat-flat-button (click)="save()" matTooltip="Speichern">
              <svg-icon>speichern</svg-icon>
              Speichern
            </button>
          }
        }
      @if (zusatzdaten.lastError) {
        <h2>
          <svg-icon>error</svg-icon> Fehler: {{zusatzdaten.lastError.comment}}
        </h2>
      }
    </div>
  </div>
}
